/**
 * 系统管理 管理员管理
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item style="margin-top: 20px;">专利管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索："></el-form-item> -->
      <el-form-item>
        会员名称：
        <el-select size="small" v-model="formInline.uid" style="width:240px" filterable placeholder="请选择">
          <el-option v-for="type in userArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <div style="float: right;display: flex;">
        <el-button size="small" type="primary" icon="el-icon-edit">编辑领域</el-button>
      </div>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="uid" v-if="idShow">
      </el-table-column>
      <!-- <el-table-column align="center" prop="deptName" label="公司" width="120">
      </el-table-column> -->
      <el-table-column align="center" prop="title" label="标题">
      </el-table-column>
      <el-table-column align="center" prop="applicationNumberCode" label="专利号">
      </el-table-column>
      <el-table-column align="center" prop="documentNumber" label="公开(公告)号">
      </el-table-column>
      <el-table-column align="center" prop="documentDate" label="公开(公告)日">
      </el-table-column>
      <el-table-column align="center" prop="type" label="专利类型">
      </el-table-column>
      <el-table-column align="center" prop="applicant" label="申请人">
      </el-table-column>
      <el-table-column align="center" prop="mainIpc" label="主分类号">
      </el-table-column>
      <el-table-column align="center" prop="technology" label="技术领域">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑领域</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="850px" @click='closeDialog("edit")'>
      <el-form label-width="100px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input size="small" v-model="editForm.title" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="专利号" prop="applicationNumberCode">
           <el-input size="small" v-model="editForm.applicationNumberCode" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="公开(公告)号" prop="documentNumber">
          <el-input size="small" v-model="editForm.documentNumber" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="专利类型" prop="type">
          <el-input size="small" v-model="editForm.type" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="申请人" prop="applicant">
          <el-input size="small" v-model="editForm.applicant" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="主分类号" prop="mainIpc">
          <el-input size="small" v-model="editForm.mainIpc" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="技术领域" prop="technology">
          <el-radio-group v-model="editForm.technology">
            <el-radio v-for="(item,index) in technologyData" :key="index" :label="item">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="saveTechnology">保存</el-button>
      </div>
    </el-dialog>

    <!-- 添加搜索值弹窗 -->
    <el-dialog :visible.sync="addSearchShow" title="添加检索式值" :close-on-click-modal="false" width="40%" @click="closeDialog('addSearchShow')">
      <el-form :model="addSearchForm" label-width="120px">
        <el-form-item label="检索式值：" prop="value">
          <el-input size="small" v-model="addSearchForm.value" auto-complete="off" placeholder="请输入检索式值"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitAddSearchForm()">确定</el-button>
          <el-button size="small" @click='closeDialog("addSearchForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
    <!-- 导入搜索值弹窗 -->
    <el-dialog :visible.sync="importSearchShow" :close-on-click-modal="false" width="40%" @click="closeDialog('importSearchShow')">
      <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M
                    <!-- <button @click="downloadSearchExcel()" style="margin-left: 15px;cursor: pointer">下载模板</button> -->
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  userSave,
  userDelete,
  userPwd,
  userExpireToken,
  userFlashCache,
  userLock,
  UserDeptTree,
  UserDeptSave,
  UserDeptdeptTree,
  UserChangeDept,
  getRoleList,
  getUserSearch,
  delSearchValue,
  delCheckSearchValue,
  addSearchValue,
  importSearchValue,
  downloadSearchExcel,
  webUrl,
  getUserPatentList,
  getSelectUserList,
  editPatentTechnology,
  editCheckPatentTechnology,
  getTechnologyList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      idShow: false, //列表uid不显示
      title: '添加管理员',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      searchShow: false, //控制检索式显示与隐藏
      addSearchShow: false, //控制添加检索式显示与隐藏
      importSearchShow: false, //控制导入检索式显示与隐藏
      // 编辑与添加
      editForm: {
        id: '',
        title: '',
        applicationNumberCode: '',
        documentNumber: '',
        type: '',
        applicant: '',
        mainIpc: '',
        technology: ''
      },
      // 选择数据
      selectdata: [],
      // 
      selectSearchData: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        real_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // {
          //   pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
          //   required: true,
          //   message: '请输入正确的手机号',
          //   trigger: 'blur'
          // }
        ],
        // email: [
        //   { required: true, message: '请输入邮箱', trigger: 'blur' },
        //   {
        //     pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        //     required: true,
        //     message: '请输入正确的邮箱',
        //     trigger: 'blur'
        //   }
        // ],
        // sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 角色
      roleArr: [],
      searchRoleArr: [],
      // 会员下拉框数据
      userArr: [],
      // 技术领域数据
      technologyData: [],
      // 请求数据参数
      formInline: {
        page: 1,
        ps: 10,
        uid: '',
      },
      // 检索式弹窗数据模型
      searchData: {
        uid: 0,
        search_field: '',
        field_desc: '',
        name: ''
      },
      addSearchForm: {
        value: ''
      },
      //用户数据
      userData: [],
      searchValue: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/patent/admin/importSearchValue',
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    // this.getRole()
    this.getUserSelectArr()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/users/importUserExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },

    // 获取数据方法
    getdata() {
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(this.formInline.uid.length <= 0){
        this.$message({
          type: 'warning',
          message: '请选择会员！'
        })
        return false
      }
       this.loading = true
       getUserPatentList(this.formInline)
       .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 获取角色
    getRole(){
      getRoleList()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.roleArr = res.data.roleOne
                  this.searchRoleArr = res.data.roleTwo
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    // 修改type
    editType: function(index, row) {
      this.loading = true
      let parm = {
        lock: '',
        userId: '',
        token: localStorage.getItem('logintoken')
      }
      parm.userId = row.userId
      let lock = row.isLock
      if (lock == 'N') {
        parm.lock = 'Y'
      } else {
        parm.lock = 'N'
      }
      // 修改状态
      userLock(parm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.getdata(this.formInline)
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      // 先获取技术领域
      let param = {}
      getTechnologyList(param)
      .then(res=>{
        if(res.code == 200){
          this.technologyData = res.data
          this.editFormVisible = true
          this.title = '编辑技术领域'
          this.editForm.id = row.id
          this.editForm.title = row.title
          this.editForm.applicationNumberCode = row.applicationNumberCode
          this.editForm.documentNumber = row.documentNumber
          this.editForm.applicant = row.applicant
          this.editForm.type = row.type
          this.editForm.mainIpc = row.mainIpc
          this.editForm.technology = row.technology
        }else{
          this.$message({
            type: 'warning',
            message: '专利信息查询失败,请稍后再试!'
          })
        }
      })
    },
    // 删除搜索值(单个)
    delSearchValue: function(index, row) {
      console.log(row.id)
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delSearchValue({'id':row.id,uid:this.searchData.uid})
        .then(res=>{
          if(res.code == 200){
            console.log(res)
            this.searchValue = res.data
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err=>{

        })
      })
      .catch(err=>{
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    // 删除搜索值(勾选)
    delCheckSearchValue() {
      const checkedArr = this.selectSearchData;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定删除勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const delParam = {ids:idStr,uid:this.searchData.uid}
      delCheckSearchValue(delParam)
      .then(res=>{
         if(res.code == 200){
            console.log(res)
            this.searchValue = res.data
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    })
    .catch(() => {
      this.$message({
        type: 'info',
        message: '已取消'
      })
    })
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          userSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 显示部门设置
    handleunit: function(index, row) {
      this.unitAccessshow = true
      let parms = 0
      UserDeptdeptTree(parms)
        .then(res => {
          if (res.data.success) {
            this.UserDept = this.changeArr(res.data.data)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('配置权限失败,请稍后再试！')
        })
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    // 保存部门
    unitPermSave() {
      let len = this.selectdata
      let ids = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          ids.push(len[i].userId)
        }
      }
      this.unitparm.userIds = ids.join(',')
      UserChangeDept(this.unitparm)
        .then(res => {
          this.unitAccessshow = false
          if (res.success) {
            this.$message({
              type: 'success',
              message: '部门设置成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('部门设置失败,请稍后再试！')
        })
    },
    sexFormat(row,column){
      if(row.sex == 1){
          return '男'
      }else if(row.sex == 2){
          return '女'
      }else{
          return '保密'
      }
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    selectSearchChange(val) {
      this.selectSearchData = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }else if(dialog == 'addSearchForm'){
        this.addSearchShow = false
      }else if(dialog == 'importSearchShow'){
        this.importSearchShow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          const delParam ={'uid':row.uid};
          userDelete(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    // 重置密码
    resetpwd(index, row) {
      this.$confirm('确定要重置密码吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const reParam = {uid:row.uid};
          userPwd(reParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '重置密码成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('重置密码失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消重置密码！'
          })
        })
    },
    // 检索式
    searchFormula: function(index, row) {
      this.searchShow = true
      getUserSearch({'uid':row.uid})
      .then(res=>{
        if(res.code == 200){
            // console.log(res)
            this.searchData.uid = row.uid
            this.searchData.search_field = res.data.search_field
            this.searchData.field_desc = res.data.field_desc
            this.searchData.name = res.data.admin_name
            this.searchValue = res.data.search_value
        }
      })
      .catch(err=>{
        this.$message.error('系统错误!')
      })
    },
    //数据格式化
    changeArr(data) {
      var pos = {}
      var tree = []
      var i = 0
      while (data.length != 0) {
        if (data[i].pId == 0) {
          tree.push({
            id: data[i].id,
            name: data[i].name,
            pId: data[i].pId,
            open: data[i].open,
            checked: data[i].checked,
            children: []
          })
          pos[data[i].id] = [tree.length - 1]
          data.splice(i, 1)
          i--
        } else {
          var posArr = pos[data[i].pId]
          if (posArr != undefined) {
            var obj = tree[posArr[0]]
            for (var j = 1; j < posArr.length; j++) {
              obj = obj.children[posArr[j]]
            }

            obj.children.push({
              id: data[i].id,
              name: data[i].name,
              pId: data[i].pId,
              open: data[i].open,
              checked: data[i].checked,
              children: []
            })
            pos[data[i].id] = posArr.concat([obj.children.length - 1])
            data.splice(i, 1)
            i--
          }
        }
        i++
        if (i > data.length - 1) {
          i = 0
        }
      }
      return tree
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      return change
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        userId: this.saveroleId,
        deptIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.deptIds = JSON.stringify(moduleIds)
      }
      UserDeptSave(parm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.dataAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 刷新缓存
    refreshCache(index, row) {
      this.$message({
            type: 'info',
            message: '暂未开放'
      })
      return false;
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    },
    // 显示添加检索式值页面
    handleAddSearch(){
      this.addSearchForm.value = ''
      this.addSearchShow = true

    },
    handleImportSearch(){
      this.importSearchShow = true

    },
    // 提交添加检索式值表单
    submitAddSearchForm(){
      console.log(this.addSearchForm)
      const addParam = {uid:this.searchData.uid,value:this.addSearchForm.value}
      addSearchValue(addParam)
      .then(res=>{
        if(res.code == 200){
          this.searchValue = res.data
          this.addSearchShow = false
          this.$message({
              type: 'success',
              message: res.msg
            })
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err=>{
          this.$message({
              type: 'error',
              message: '系统错误,请稍后再试!'
            })
      })
    },
    // 下载用户导入excel模板
    downloadSearchExcel(){
      downloadSearchExcel()
        .then(res => {
          if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '模板下载成功!'
              })
              window.location.href = res.data.value
          } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
    },
    // 查询会员下拉框数据
    getUserSelectArr() {
      let param = {}
      getSelectUserList(param)
      .then(res=>{
        if(res.code == 200){
          this.userArr = res.data
        }
      })
    },
    // 查询技术领域数据
    getTechnologyData() {
      let param = {}
      getTechnologyList(param)
      .then(res=>{
        if(res.code == 200){
          this.technologyData = this.data
        }
      })
    },
    // 保存技术领域(单个)
    saveTechnology() {
      let documentNumber = this.editForm.documentNumber
      let technology = this.editForm.technology
      if(documentNumber.length <= 0 || technology <= 0){
        this.$message({
          type: 'error',
          message: '技术领域不能为空!'
        })
        return false
      }
      let param = {
        documentNumber: documentNumber,
        technology: technology
      }
      editPatentTechnology(param)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.editFormVisible = false
          this.getdata()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
</style>

 


// WEBPACK FOOTER //
// src/views/system/technology.vue